export default {"src":"/uk/_next/static/media/upload-successful.79db769a.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};